/**
 * Com es diu un usuari, en un sol lloc.
 *
 * Hi ha tres menes de comptes i cadascuna porta el nom en un camp diferent:
 *
 * - Les **persones** tenen nom, cognoms i correu.
 * - Els **grups d'examen** no tenen ni correu ni contrasenya: només `displayName`
 *   («Grup 07»). Vegeu la migració 010.
 * - Els comptes antics fets a mà poden tenir només correu.
 *
 * Fins al 07/08/2026 cada pantalla ho resolia pel seu compte amb una cadena de
 * `||`, i cap mirava `displayName`. Conseqüència: quan un grup entregava un
 * examen, l'instructor veia **«Desconegut»** a la llista del cas i a la pantalla
 * de qualificació, i no sabia quin grup havia entregat què. Amb una aula sencera
 * fent l'examen, això vol dir no poder corregir.
 *
 * L'ordre no és arbitrari: `displayName` va primer perquè, quan hi és, és el nom
 * que ha triat l'instructor i el que surt imprès a la targeta.
 */

export const nomUsuari = (usuari, perDefecte = 'Desconegut') => {
  if (!usuari) return perDefecte;
  if (usuari.displayName) return usuari.displayName;
  if (usuari.firstName && usuari.lastName) return `${usuari.firstName} ${usuari.lastName}`;
  if (usuari.firstName) return usuari.firstName;
  if (usuari.email) return usuari.email;
  return perDefecte;
};

/**
 * La lletra de l'avatar. Sobre «Grup 07» dona «G», que no distingeix un grup de
 * l'altre; per això les pantalles que en mostren molts han d'ensenyar el nom
 * sencer al costat i no confiar només en la inicial.
 */
export const inicialUsuari = (usuari) => {
  const nom = nomUsuari(usuari, '?');
  return nom.charAt(0).toUpperCase();
};

/**
 * El nom de qui ha fet un exercici, sigui una persona, un grup o un equip.
 */
export const nomExecutor = (assessment, perDefecte = 'Desconegut') => {
  if (!assessment) return perDefecte;
  if (assessment.team?.name) return assessment.team.name;
  return nomUsuari(assessment.user, perDefecte);
};
